import { FC, MouseEvent, ReactNode } from 'react'
import {
  List as ListIcon
} from 'lucide-react'
import { SEARCH_TYPE_ICONS_MAP } from 'constants/search-icons'

export interface Crumb {
  label: string
  href: string
  onClickOverride?: (e: MouseEvent) => void
  analytics?: {
    aol?: string | string[]
    category: string
    action: string
    label: string
  }
}

interface Props {
  crumbs: Crumb[]
  current: string
  icon: keyof typeof SEARCH_TYPE_ICONS_MAP
  viewAllLink?: string
  children?: ReactNode
}

const Breadcrumbs: FC<Props> = ({
  crumbs,
  current,
  icon,
  viewAllLink,
  children
}) => {
  const Icon = SEARCH_TYPE_ICONS_MAP[icon]

  return (
    <nav className='flex items-center nowrap flex-wrap'>
      <Icon name={icon} className='w7 hl7 mr4' />
      {crumbs.map(({ label, href, onClickOverride, analytics }) => (
        <div key={href} className='pr4'>
          <a
            className='no-underline hover-underline'
            href={href}
            onClick={onClickOverride}
            data-event-category={analytics?.category}
            data-event-action={analytics?.action}
            data-event-label={analytics?.label}
            data-event-aol={analytics?.aol}
          >
            {label}
          </a>
          {'\xa0 >'}
        </div>
      ))}
      <div className='pr6'>{current}</div>
      {viewAllLink !== undefined && viewAllLink !== '' && (
        <a href={viewAllLink} className='no-underline hover-underline flex items-center justify-center'>
          <ListIcon className='w6 hl6 mr2' />
          View all
        </a>
      )}
      {children}
    </nav>
  )
}

export default Breadcrumbs
